import { getLangSwitchList } from '@umu/umu-lang-switch';

const getLangOptions = () => {
    const langOptions = getLangSwitchList();
    const newLangOptions = langOptions.map((item) => {
        return {
            val: item.key,
            text: item.value,
        };
    });
    return newLangOptions;
};

export const langOptions = getLangOptions();
